import React from 'react'

import ContractEntity from 'utils/__interfaces/Perimeter/ContractEntity'
import SearchResultItem from 'utils/__interfaces/Perimeter/SearchResultItem'

const SearchContractAdapter = (
  searchResultItems: ContractEntity[]
): SearchResultItem[] => {
  if (
    searchResultItems?.length === undefined ||
    searchResultItems?.length < 1
  ) {
    return []
  }

  return searchResultItems.map(({ id, name, address, numeroContratSAP }) => ({
    id,
    line1: <>{name}</>,
    lineNumContract: <>{numeroContratSAP}</>,
    line2: <>{address}</>,
  }))
}

export default SearchContractAdapter
